import { useMemo } from 'react';
import { getSeoState, SeoState } from './seo.utils';

export const useSeo = (pathname: string, fallbackCategory: string, rawConfig?: string): SeoState => {
  return useMemo(() => getSeoState(pathname, fallbackCategory, rawConfig), [pathname, fallbackCategory, rawConfig]);
};
